import React from 'react';
import PropTypes from 'prop-types';
import { Transition as ReactTransition } from 'react-transition-group';

import Transition from './transition';

import Wallpaper from './';

class WallpaperWithTransition extends React.Component {
  constructor(props) {
    super(props);

    this.onEnter = this.onEnter.bind(this);
  }

  onEnter(component) {
    new Transition({
      prevType: false,
      newType: this.props.route.type,
      component: component,
      animate: false, // We don't need to animate this
    });
  }

  componentDidUpdate(prevProps) {
    // We accept wrapped store components and regular components.
    let component = this.node;
    if (component.getWrappedInstance) {
      component = component.getWrappedInstance().node;
    }

    new Transition({
      prevType: prevProps.route.type,
      newType: this.props.route.type,
      component,
    });
  }

  render() {
    return (
      <ReactTransition
        appear={this.props.appear}
        in={this.props.in}
        timeout={{ in: 0, out: 1000 }}
        onEnter={this.onEnter}
      >
        <Wallpaper {...this.props} ref={(node) => (this.node = node)} />
      </ReactTransition>
    );
  }
}

WallpaperWithTransition.propTypes = {
  appear: PropTypes.bool,
  in: PropTypes.bool,
  route: PropTypes.object,
};

export default WallpaperWithTransition;
